export const constants = {
  titlePrefix: "By",
};
